import useApiMutation from 'shared/hooks/use-api-mutation';
import {DistanceProps} from '../types';
import citiesKeys from '../util/cities-keys';
import useQueryHelpers from 'shared/hooks/use-query-helpers';

const useEditDistance = (cityId: string, distanceId: string) => {
  const {update} = useQueryHelpers();

  const onSuccess = (data: DistanceProps) =>
    update(citiesKeys.distances(cityId), data);

  return useApiMutation<DistanceProps>({
    url: `/distances/${distanceId}`,
    method: 'PATCH',
    errorTitle: 'Erro ao atualizar distância',
    successTitle: 'Distância cidade',
    successMessage: 'Distância atualizada com sucesso',
    redirectUrl: `/settings/cities/${cityId}/distances`,
    onSuccess,
  });
};

export default useEditDistance;
